module.exports = __webpack_public_path__ + "img/home-02.dd6effd1.svg";